<template>
  <v-card flat>
    <v-card-text>
      {{ $t("audit_score") }} ({{ auditScore }}%)
      <v-progress-linear
        background-color="blue-grey"
        :color="currentColor"
        :value="auditScore"
      ></v-progress-linear>
    </v-card-text>
  </v-card>
</template>

<i18n>
{
  "de": {
    "audit_score": "Audit Score - Erfüllungsgrad des Audits"
  },
  "en": {
    "audit_score": "Audit Score - Erfüllungsgrad des Audits"
  }
}
</i18n>

<script>
export default {
  props: {
    auditScore: {
      // TODO: Macht das so sinn? -> Geht es eher um
      type: [Number, String],
      default: 70
    }
  },
  computed: {
    currentColor() {
      if (this.auditScore <= 50) {
        return "red";
      } else if (this.auditScore <= 90) {
        return "yellow";
      } else {
        return "green";
      }
    }
  }
};
</script>
